import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Pages.css';
import './css/Fonts.css';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { services } from '../content';

function Services() {
  return (
    <div className="page">
      <header className="page-header">
        <Container>
          <p className="page-eyebrow">Services</p>
          <h1 className="page-title">We make the systems you own work together</h1>
          <p className="page-lead">
            InfoRight helps mining companies integrate and use information from separate, disparate
            systems. We help you collect and use the right data to measure and improve end-to-end
            processes — from extraction to handling to processing and beyond.
          </p>
        </Container>
      </header>

      <Container className="page-section">
        <Row className="g-4">
          {services.map((service) => (
            <Col md={6} key={service.id}>
              <div className="service-card h-100">
                <h2 className="service-card-title">{service.name}</h2>
                <p className="service-card-text">{service.description}</p>
                <ul className="feature-list">
                  {service.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <section className="engagement">
        <Container>
          <h2 className="section-title text-center">How engagements work</h2>
          <Row className="g-4 mt-2">
            <Col md={4}>
              <div className="step-card">
                <p className="step-number">01</p>
                <h3 className="step-title">Find the real process</h3>
                <p className="step-text">
                  We map how information actually moves today — including the spreadsheets and paper
                  nobody mentions in the org chart.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="step-card">
                <p className="step-number">02</p>
                <h3 className="step-title">Connect the systems</h3>
                <p className="step-text">
                  We integrate the sources that hold your project, financial, and operational data so
                  the numbers agree with each other.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="step-card">
                <p className="step-number">03</p>
                <h3 className="step-title">Measure and improve</h3>
                <p className="step-text">
                  With the right data in place, we help you select metrics that drive end-to-end
                  process improvement — and keep them running.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="cta-band">
        <Container className="text-center">
          <h2 className="cta-title">Let's talk about your systems</h2>
          <p className="cta-text">
            Consulting and managed services arrangements are both available.
          </p>
          <Button variant="" as={Link} to="/contact" className="btn-light-ir">
            Contact Us
          </Button>
        </Container>
      </section>
    </div>
  );
}

export default Services;
